/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type ValuesEnumType = "a" | "b" | "c" | "d" | "e" | "f" | "g";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingEnergyDiagnostics_listing$ref: FragmentReference;
declare export opaque type AggregatesListingEnergyDiagnostics_listing$fragmentType: AggregatesListingEnergyDiagnostics_listing$ref;
export type AggregatesListingEnergyDiagnostics_listing = {|
  +energyClass: ?ValuesEnumType,
  +greenhouseGasEmissionsClass: ?ValuesEnumType,
  +energyIndex: ?number,
  +greenhouseGasEmissionsIndex: ?number,
  +energyCertificateVersion: ?string,
  +energyInspectionDate: ?string,
  +energyReferenceYear: ?string,
  +energyCostCurrency: ?string,
  +estimatedLowerEnergyCost: ?number,
  +estimatedHigherEnergyCost: ?number,
  +$refType: AggregatesListingEnergyDiagnostics_listing$ref,
|};
export type AggregatesListingEnergyDiagnostics_listing$data = AggregatesListingEnergyDiagnostics_listing;
export type AggregatesListingEnergyDiagnostics_listing$key = {
  +$data?: AggregatesListingEnergyDiagnostics_listing$data,
  +$fragmentRefs: AggregatesListingEnergyDiagnostics_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingEnergyDiagnostics_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "energyClass",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "greenhouseGasEmissionsClass",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "energyIndex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "greenhouseGasEmissionsIndex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "energyCertificateVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "energyInspectionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "energyReferenceYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "energyCostCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedLowerEnergyCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedHigherEnergyCost",
      "storageKey": null
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '68a67c9f9058d9ee24c30138e3468106';

export default node;
